/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiSingleRecordFieldContainerConfig} from "./UiSingleRecordFieldContainerConfig";
import {UiColorConfig} from "./UiColorConfig";
import {UiPanelHeaderFieldConfig} from "./UiPanelHeaderFieldConfig";
import {UiToolbarConfig} from "./UiToolbarConfig";
import {UiToolButtonConfig} from "./UiToolButtonConfig";
import {UiItemViewConfig} from "./UiItemViewConfig";
import {UiSingleRecordFieldContainerCommandHandler} from "./UiSingleRecordFieldContainerConfig";
import {UiSingleRecordFieldContainerEventSource} from "./UiSingleRecordFieldContainerConfig";

export enum UiPanel_HeaderComponentMinimizationPolicy {
	LEFT_COMPONENT_FIRST, RIGHT_COMPONENT_FIRST
}

export interface UiPanelConfig extends UiComponentConfig, UiSingleRecordFieldContainerConfig {
	_type?: string;
	headerBackgroundColor?: UiColorConfig;
	headerFontColor?: UiColorConfig;
	bodyBackgroundColor?: UiColorConfig;
	icon?: string;
	title?: string;
	leftHeaderField?: UiPanelHeaderFieldConfig;
	rightHeaderField?: UiPanelHeaderFieldConfig;
	initialHeaderFieldValues?: {[name: string]: any};
	headerComponentMinimizationPolicy?: UiPanel_HeaderComponentMinimizationPolicy;
	hideTitleBar?: boolean;
	maximizable?: boolean;
	toolbar?: UiToolbarConfig;
	content?: UiComponentConfig;
	padding?: number;
	toolButtons?: UiToolButtonConfig[]
}

export interface UiPanelCommandHandler extends UiSingleRecordFieldContainerCommandHandler {
	setContent(content: UiComponentConfig): void;
	setLeftHeaderField(field: UiPanelHeaderFieldConfig): void;
	setRightHeaderField(field: UiPanelHeaderFieldConfig): void;
	setTitle(title: string): void;
	setIcon(icon: string): void;
	setToolbar(toolbar: UiToolbarConfig): void;
	setMaximizable(maximizable: boolean): void;
	setMaximized(maximized: boolean): void;
	setToolButtons(toolButtons: UiToolButtonConfig[]): void;
	showToolButtonDropDown(toolButtonId: string, dropDownItemView: UiItemViewConfig, dropDownWidth: number): void;
}

export interface UiPanelEventSource extends UiSingleRecordFieldContainerEventSource {
	onToolButtonClicked: TeamAppsEvent<UiPanel_ToolButtonClickedEvent>;
	onToolButtonDropDownItemClicked: TeamAppsEvent<UiPanel_ToolButtonDropDownItemClickedEvent>;
}

export interface UiPanel_ToolButtonClickedEvent extends UiEvent {
	_type: "UiPanel.toolButtonClicked";
	redundancyKey?: string;
	toolButtonId: string
}

export interface UiPanel_ToolButtonDropDownItemClickedEvent extends UiEvent {
	_type: "UiPanel.toolButtonDropDownItemClicked";
	redundancyKey?: string;
	toolButtonId: string;
	itemId: any
}

